export const fetchCrmInteractionDateHistogram = (request, { signal, ...data }) =>
  request({
    method: 'post',
    pathname: '/api/crm-interaction/date-histogram',
    data,
    signal,
  });

export const fetchCrmInteractionQuery = (request, { signal, ...data }) =>
  request({
    method: 'post',
    pathname: '/api/crm-interaction/query',
    data,
    signal,
  });

export const fetchCrmInteraction = (request, { id, signal }) =>
  request({
    method: 'get',
    pathname: `/api/crm-interaction/${id}`,
    signal,
    notShowErrorMessage: true,
  });

export const createCrmInteraction = (request, { signal, ...data }) =>
  request({
    method: 'post',
    pathname: '/api/crm-interaction/create',
    data,
    signal,
  });

export const updateCrmInteraction =(request, { signal, ...data }) =>
  request({
    method: 'post',
    pathname: '/api/crm-interaction/update',
    data,
    signal,
  });

export const deleteCrmInteractions = (request, { ids, signal }) =>
  request({
    method: 'post',
    pathname: '/api/crm-interaction/delete',
    data: ids,
    signal,
  });
